// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"d4f2abdf","470":"d4f2abdf","493":"d4f2abdf","971":"2e5b2212"}[chunkId] + ".chunk.css";
};